module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-6C083FZ2WR"],"gtagConfig":{},"pluginConfig":{"head":false}},
    }]
